/**
 * 初期設定（first-run goal setup）— the step order and transitions, kept out of
 * GoalEditScreen so they can be tested without rendering the screen.
 * TASK_SHOKI_SETTEI_FLOW.md
 *
 * `setupStep` on goals = the NEXT step to run ('done' when the sequence is complete).
 */

/** Step just saved -> step to run next. null ends the sequence. */
export const FUNNEL_ORDER = ['goal', 'subkgi', 'kpi1', 'kpi2', 'kpi3', 'actions'];

export const FUNNEL_LABEL = {
  subkgi: '次へ: 追加KGI（任意）',
  kpi1: '次へ: 注力指標①を決める',
  kpi2: '次へ: 注力指標②（任意）',
  kpi3: '次へ: 注力指標③（任意）',
  actions: '次へ: 毎日の行動プランを決める',
};

export function nextFunnelStep(step) {
  const i = FUNNEL_ORDER.indexOf(step);
  return i >= 0 && i < FUNNEL_ORDER.length - 1 ? FUNNEL_ORDER[i + 1] : null;
}

/** Value written to goals.setupStep together with the save of `step`. */
export function setupStepAfter(step) {
  return nextFunnelStep(step) || 'done';
}

/** 「設定しない」 at ② or ③: an empty ② makes ③ moot, so both skip straight to the plan. */
export const SKIP_OPTIONAL_TARGET = 'actions';

/**
 * Where to resume when the screen opens. null = no first-run sequence pending
 * (accounts set up before `setupStep` existed have no field and keep the item menu).
 */
export function resumeStepFrom(goals) {
  const s = goals?.setupStep;
  return s && s !== 'done' && FUNNEL_ORDER.includes(s) ? s : null;
}

/**
 * Screen state for entering a step: { scope, editTarget, phase, propose }.
 * `propose` says what the screen must kick off after applying the state:
 *   'metric'  -> AI proposal for that 注力 slot (startMetricFlow)
 *   'actions' -> AI action-plan proposal
 *   null      -> nothing (the step asks first)
 * `opts.resume` = the screen just opened (kpi1 then waits for a tap: the AI needs the POS snapshot).
 */
export function funnelStepView(step, { resume = false } = {}) {
  if (!step) return { scope: null, editTarget: null, phase: 'setup_done', propose: null };
  if (step === 'goal') return { scope: 'goal', editTarget: 'goal', phase: 'goal_setup', propose: null };
  if (step === 'subkgi') return { scope: 'subkgi', editTarget: 'goal', phase: 'goal_setup', propose: null };
  if (step === 'actions') return { scope: 'actions', editTarget: 'actions', phase: 'actions_proposed', propose: 'actions' };
  if (step === 'kpi2' || step === 'kpi3') return { scope: step, editTarget: 'metric', phase: 'ask_slot', propose: null };
  if (step === 'kpi1') {
    return resume
      ? { scope: 'kpi1', editTarget: 'metric', phase: 'resume', propose: null }
      : { scope: 'kpi1', editTarget: 'metric', phase: null, propose: 'metric' };
  }
  return null;
}
